module.exports = __webpack_public_path__ + "img/powered-by.37f37f66.png";